import NavbarTP from "./ordini/NavbarTopORD";
import OrdiniUrgenti from "./ordini/OrdiniUrgenti";
import Rimessi from "./ordini/Rimessi";
import Anomalie from "./ordini/Anomalie";
import BarreFornitori from "./ordini/BarreFornitori";
import InfoOrdini from "./ordini/InfoOrdini";
import CardFix from "./ordini/CardFix";
import CrossDocking from "./ordini/CrossDocking";
import TortaOggi from "./ordini/TortaOggi";
import BarraImporto from "./ordini/BarraImporto";
import MappaPercorso from "./ordini/MappaPercorso";
import "../App.css";
import "./ordini/ordini-liquid.css";

function Home() {
  return (
    <div className="main-container ordini-dashboard-shell">
      <NavbarTP />

      <main className="ordini ordini-dashboard-grid">
        {/* ROW 1 / COL 1 — due widget affiancati */}
        <section className="ord-cell ord-summary-cell">
          <div className="ord-summary-pair">
            <div className="ord-widget-slot">
              <TortaOggi />
            </div>

            <div className="ord-widget-slot">
              <BarraImporto />
            </div>
          </div>
        </section>

        <section className="ord-cell">
          <BarreFornitori />
        </section>

        <section className="ord-cell">
          <CardFix />
        </section>

        {/* ROW 2 */}
        <section className="ord-cell">
          <OrdiniUrgenti />
        </section>

        <section className="ord-cell">
          <Rimessi />
        </section>

        <section className="ord-cell">
          <Anomalie />
        </section>

        {/* ROW 3 */}
        <section className="ord-cell">
          <InfoOrdini />
        </section>

        <section className="ord-cell">
          <CrossDocking />
        </section>

        <section className="ord-cell">
          <MappaPercorso />
        </section>
      </main>
    </div>
  );
}

export default Home;
